import { SortOrder } from "./sortOrder";

export type SortRequest<T> = {
    sortProperty: T;
    sortOrder: SortOrder;
};

export class SortRequestClass<T> implements SortRequest<T> {
    constructor(property: T, order: SortOrder) {
        this.sortProperty = property;
        this.sortOrder = order;
    }
    sortProperty: T;
    sortOrder: SortOrder;
}
